<mat-form-field
 appearance="outline" 
  [matMenuTriggerFor]="pickerMenu" 
  #menuTrigger="matMenuTrigger" 
  (menuOpened)="onMenuOpened()"
  class="advanced-picker-form-field"
  
>
  <mat-label>Vremenski period</mat-label>
  
  <input matInput [value]="displayText" readonly class="pointer-input" style="cursor: pointer;">
  <mat-icon matSuffix>
    calendar_today
  </mat-icon>
</mat-form-field>

<mat-menu #pickerMenu="matMenu" class="advanced-picker-menu">
  <div class="popover-content" (click)="$event.stopPropagation()">
    
    <div class="left-column">
      <h3>Apsolutni vremenski opseg</h3>
      
      <mat-form-field appearance="outline">
        <mat-label>Od</mat-label>
        <input matInput [matDatepicker]="fromPicker"  [(ngModel)]="tempFrom" [max]="tempTo">
        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Do</mat-label>
        <input matInput [matDatepicker]="toPicker" [(ngModel)]="tempTo" [min]="tempFrom">
        <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>

      <button mat-flat-button color="primary" class="apply-btn" 
              [disabled]="!tempFrom || !tempTo" 
              (click)="applyManualRange()">
        Primeni opseg
      </button>
    </div>

    <mat-divider [vertical]="true"></mat-divider>

    <div class="right-column">
      <h3>Brzi opsezi</h3>
      <div class="quick-ranges-list">
        <button mat-button *ngFor="let range of quickRanges" (click)="selectQuickRange(range)" class="quick-range-item" [class.active-range]="range.label === activeRangeLabel">
          {{ range.label }}
        </button>
      </div>
    </div>

  </div>
</mat-menu>